import React from 'react';
import './style.css'
import QRCode from "react-qr-code";
import { useSelector } from 'react-redux';
import { store } from '../../../redux/store';
import { setGoHome } from '../../../redux/slices/initLoad/types';
import ChangeLann from '../../changeLang'
import { useTranslation } from 'react-i18next';
const Index = ({ showBack = true, showImageTop = true, showLamp = true,children, showLogo=true, showFooter=true, setShowListProduct, setShowSpecials, goHome, goCategories }) => {

   const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

  const [showModal, setShowModal] = React.useState(false);
  const [showBoost, setshowBoost] = React.useState(false);
  const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState("");

  const handleButtonClick = () => {
    if (setShowListProduct) {
      setShowListProduct(false); 
    }

    if (goHome) {
      goHome(false)
    }
  };
  


   const {
      goHomeInit
   } = useSelector((state) => state.initLoad);


  const validScret = () => {

    if (secret === '') {
      alert('Debe ingresar el pin')
    }

    if (secret === "2355") {
       window.location.reload();
    } else {
       alert('Code invalid')
    }
    
  }
  
    return (
      <div className='backgroundlayout' style={{
        flex: 1,
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
       
      }}>

        
        <div>
          {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}
          

          <div className='contentChild' >
            
              
               

            <div className='nav-menu-bar' style={{
              marginTop: 0,
              width: '100%',
              position: 'relative'
            
            }}>

             
              {showLogo &&
              <div style={{
               
                paddingTop: 20,
                paddingBottom: 20,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: showBack ? 'space-between':'center',
            
                }}>
                  
                  <div style={{ display: 'flex',
                      alignItems: 'center',
                    justifyContent: 'space-between',
                    width: "80%"
                  }}>
                     {showBack ? (
                        <div
                            onClick={()=>handleButtonClick()}
                        style={{
                                  display: 'flex',
                                   marginLeft: 20,
                                width: 170,
                                height: 60,
                                backgroundColor:
                                 "#217ED3",
                                borderRadius: 92,
                                marginHorizontal: 10,
                                justifyContent: 'space-around',
                                paddingHorizontal: 20,
                                alignItems: 'center',
                                flexDirection: 'row',
                            }}>
                           
                              <p  style={{color: 'white', fontWeight: 'bold', fontSize: 24, fontFamily: 'Arial'}}>{langEng ? 'Go Back' : 'Atras'}</p>
                          </div>
                    ): (
                      <>
                        <p style={{color: 'transparent'}}>.</p>
                      </>
            )}

                  </div>
                  
                  <div style={{
                      alignItems: 'center',}}   >
                       <div style={{
                      
                        display: 'flex',
                          alignItems: 'center',
                              position: 'relative',
                              zIndex: 999,
                              justifyContent: 'end',}}>
                        <div onClick={()=>setShowModal('#')} target='_blank'> <img
                        style={{
                          width: 28,
                            height: 28,
                            marginInline: 10
                        
                      }}
                      src={require('./assets/instagram.png')}
                      alt="Logo"
                      /> 
                      </div>

                      <div target='_blank' onClick={()=>setShowModal('#')}> 
                        <img
                          style={{
                              width: 28,
                                height: 28,
                                marginInline: 10
                        }}
                          src={require('./assets/facebook.png')}
                          alt="Logo"
                        /> 
                      </div>

                      <ChangeLann />

                    

                      {/* <div target='_blank' onClick={()=>setShowModal('https://stanciaperuvianfusion.com/?fbclid=PAZXh0bgNhZW0CMTEAAabcJIytXY618p9SWTbgSUCDqZjeqqwDe6N-mVtvD2e3OsRHHxJ4b-C03sg_aem_ySjBYnYb0DeoIbZGrDsMbQ')}> 
                        <img
                          style={{
                              width: 30,
                                height: 30,
                                marginInline: 10
                        }}
                          src={require('./assets/web.png')}
                          alt="Logo"
                        /> 
                      </div>
                             */}
                  
                    <div>
                    
                    </div>
                      </div>
                  </div>

                 
              </div>
              }
              


            

            </div>
            {children}

            
            {showFooter &&
            <div
            style={{
              position: 'absolute',
              bottom: 0,
                  alignSelf: 'center',
                
                  width: '100%',
                  left: 0,
                  zIndex: 999
                
              
            }}>
            <div
              style={{
                paddingHorizontal: 40,
                paddingVertical: 15,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                  marginTop: 5,
                gap: 20,
                    width: '100%',
                 
                
              }}>
              <div

                    onClick={() => {
                      //handleButtonClick()
                      //console.log('qlqlq')
                       store.dispatch(setGoHome(Math.random()));
                      //console.log({goHome})
                      
                  }}
                style={{
                  width: 170,
                  height: 50,
                  backgroundColor: '#217ED3',
                  borderRadius: 92,
                  marginHorizontal: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  paddingHorizontal: 20,
                  alignItems: 'center',
                  flexDirection: 'row',
                  boxSizing: 'border-box',
                  gap: 10
                
                    }}>
                    
                     <img
                  src={require('./assets/home.png')}
                  style={{
                    width: 30,
                    height: 30,
                    marginRight: 10,
                  }}
                />

                <p
                  style={{color: 'white', fontWeight: 'bold', fontSize: 20}}>
                 {langEng ? 'Home' : 'Inicio'}
                  </p>
                  </div>


                  
                  

                   <div

                    onClick={() => {
                      if (goCategories) {
                        goCategories(true)
                      }
                  }}
                    style={{
                  width: 180,
                      height: 50,
                  backgroundColor: '#217ED3',
                  borderRadius: 92,
                  marginHorizontal: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  paddingHorizontal: 40,
                  alignItems: 'center',
                  flexDirection: 'row',
                  boxSizing: 'border-box',
                  gap: 5
                  }}>
                  
                    <img
                  src={require('./assets/categorie.png')}
                  style={{
                    width: 30,
                    height: 30,
                    marginRight: 10,
                  }}
                />

                <p
                  style={{color: 'white', fontWeight: 'bold', fontSize: 20}}>
                 {langEng ? 'Categories' : 'Categorias'}
                  </p>
               
              </div>

              <div
                    onClick={() => {
                      if (setShowSpecials) {
                        setShowSpecials(true)
                      }
                }}
                style={{
                   width: 180,
                  height: 50,
                  backgroundColor: '#217ED3',
                  borderRadius: 92,
                  marginHorizontal: 10,
                  display: 'flex',
                   justifyContent: 'center',
                  paddingHorizontal: 30,
                  alignItems: 'center',
                  flexDirection: 'row',
                  boxSizing: 'border-box',
                  gap: 5

                  }}>
                     
              <img
                  src={require('./assets/promo.png')}
                  style={{
                    width: 30,
                    height: 30,
                    marginRight: 10,
                  }}
                />

                <p
                  style={{color: 'white', fontWeight: 'bold', fontSize: 20}}>
                 {langEng ? 'Specials' : 'Especiales'}
                  </p>
                
              </div>
            </div>
            <div
              style={{
                zIndex: 100,
                flexDirection: 'row',
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                paddingVertical: 5,
                  alignItems: 'center',
                marginTop: 20,
              }}>
                  <div
                    onClick={()=> setshowBoost(true)}
                style={{flexDirection: 'row', alignItems: 'center'}}>
                <p
                  style={{
                      color: '#fff',
                      fontWeight: '300',
                      textAlign: 'center',
                      fontSize: 14,
                    }}>
                 Powered by boostyourmenu.com V1.6
                </p>
              </div>
            </div>
          </div>
            }
            
            {showBoost &&
              <div onClick={ ()=> setshowBoost(false)} style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                <img
                 
                            style={{
                              width: 500,
                                height: 500,
                                marginInline: 10,
                                objectFit: 'contain',
                                zIndex: 9999
                            
                          }}
                          src={require('./assets/boost.png')}
                          alt="Logo"
                /> 
            
            </div>
            }
            

            {showModalPincode &&
              <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                
                <div style={{ position: 'absolute',background: '#fff', width: 500, height: 300, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                  <img
                      onClick={()=>setShowModalPincode(false)}
                    style={{
                      position: 'absolute',
                      top: -10,
                      
                                width: 40,
                                  height: 40,
                                  marginInline: 10,
                                  objectFit: 'contain',
                                  position: 'absolute',
                                  right: -10,
                                  zIndex: 9999
                              
                            }}
                      src={require('./assets/close.png')}
                      alt="Logo"
                  /> 
                  <h4 style={{ color: '#F40000', fontSize: 40, fontWeight: 'bold', margin: 20 }}>PIN</h4>
                  <input type='number' style={{ width: 300, height: 40 }} onChange={(e) => {
                    setScret(e.target.value)
                  }} />
                  <br /><br />
                  
                  <div style={{display: 'flex', gap: 20}}>
                    <div onClick={() => setShowModalPincode(false)} style={{background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7}}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>atras</p>
                    </div>
                    <div onClick={()=>validScret()} style={{ background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7 }}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>Enviar</p>
                  </div>
                </div>
                </div>
              </div>
            }

            <img
                onClick={()=>setShowModalPincode(true)}
                        style={{
                          width: 40,
                            height: 40,
                            marginInline: 10,
                            objectFit: 'contain',
                            position: 'absolute',
                            bottom: -1,
                            right: 0,
                            zIndex: 9999
                        
                      }}
                src={require('./assets/pincode.png')}
                alt="Logo"
            /> 
            

            

            
            {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              divBox={`0 0 256 256`}
            />
            </div>}
           
          </div>
        </div>
      </div>
     
    );
  };

export default Index;